import axios from 'axios'
import { puedeAccederPortalRh } from '@/constants/accesoRh'

function getApiRhBaseUrl () {
  const raw = (process.env.VUE_APP_RUTA_API_RH || '').trim()
  if (raw) return raw.endsWith('/') ? raw : `${raw}/`
  if (process.env.NODE_ENV === 'development') return '/api-rh/'
  return 'https://kpi.schoolofenglishadmin.com/kpi-proxy/'
}

const apiRh = axios.create({
  baseURL: getApiRhBaseUrl(),
  timeout: 45000,
  headers: { 'Content-Type': 'application/json' },
})

/**
 * Login RH: POST /usuarios.data
 * Password en texto plano (no MD5).
 * @returns {Promise<object>} fila de usuario con accessToken
 */
export async function loginApiRh (usuarioOEmail, passwordPlain) {
  const email = String(usuarioOEmail || '').trim()
  const password = String(passwordPlain || '')
  const { data } = await apiRh.post('usuarios.data', { email, password })
  const row = Array.isArray(data) ? data[0] : null
  if (!row || !row.accessToken) {
    const err = new Error('Respuesta de api-rh sin accessToken')
    err.response = { status: 401, data: { message: 'No se pudo iniciar sesión en RH' } }
    throw err
  }
  if (!puedeAccederPortalRh(row)) {
    const err = new Error('Sin acceso al portal')
    err.response = {
      status: 403,
      data: {
        message: 'Tu usuario no tiene permiso para entrar a esta aplicación. Contacta a sistemas.',
      },
    }
    throw err
  }
  return row
}

/** @deprecated usar esCorreoRh de constants/accesoRh */
export function esUsuarioRhDirecto (usuario) {
  return String(usuario || '').trim().indexOf('@') !== -1
}

export function mensajeErrorApiRh (error) {
  const code = error && error.code
  const msg = String((error && error.message) || '')
  if (code === 'ECONNABORTED' || /timeout/i.test(msg)) {
    return 'Se excedió el tiempo de espera al conectar con RH. Verifica que api-rh esté en el puerto 3004 e intenta de nuevo.'
  }
  if (code === 'ERR_NETWORK' || /Network Error/i.test(msg)) {
    return 'No hay conexión con api-rh. Revisa que el servidor esté corriendo en el puerto 3004.'
  }
  return (
    (error && error.response && error.response.data && error.response.data.message) ||
    msg ||
    'No se pudo iniciar sesión con RH'
  )
}

export { getApiRhBaseUrl }
